<template>
  <div class="page_wrapper">
    <p></p>
    <div class="box">
      <h3>Event Information</h3>
      <div class="box2">
        <div class="nested_pic"><img src="../assets/images/church.png"/></div>
        <div class="nested_txt">
          <h4>Wedding Ceremony</h4>
          <table>
            <tr>
              <th scope="row">Start Time:</th>
              <td>2:00 PM</td>
            </tr>
            <tr>
              <th scope="row">End Time:</th>
              <td>3:00 PM</td>
            </tr>
            <tr>
              <th scope="row">Place:</th>
              <td><a href="https://sjnparish.org/">St. John Neumann Parish</a> (parking available)<br/>
                380 Highland Lane<br/>
                Bryn Mawr, PA 19010<br/>
                <a href="https://www.google.com/maps/place/St.+John+Neumann+Parish/@40.0038789,-75.338113,15z/data=!4m5!3m4!1s0x0:0xfc46e032a42294fe!8m2!3d40.0038789!4d-75.338113">Google maps link</a>
              </td>
            </tr>
            <tr>
              <th scope="row">Attire:</th>
              <td>Whatever you wear to church</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="box2">
        <div class="nested_txt">
          <h4>Fair (Reception)</h4>
          <table>
            <tr>
              <th scope="row">Start Time:</th>
              <td>5:00 PM</td>
            </tr>
            <tr>
              <th scope="row">End Time:</th>
              <td>10:00 PM</td>
            </tr>
            <tr>
              <th scope="row">Place:</th>
              <td>Lucky Penny Farm <br/>
<!--                320 Wawa Rd<br/>-->
                Media, Pennsylvania 19063<br/>
                (Shuttle from Best Western)<br/>
<!--                <a href="https://goo.gl/maps/Axq9Ct3YXCd4RBo17">Google maps link</a>-->
              </td>
            </tr>
            <tr>
              <th scope="row">Attire:</th>
              <td>Whatever you want! (See FAQ)</td>
            </tr>

          </table>
        </div>
        <div class="nested_pic"><img src="../assets/images/cow.png"/></div>
      </div>

      <h3>Logistics</h3>
      <div class="box2">
        <div class="nested_txt">
          <h4>Lodging</h4>
          <p>Best Western Plus Concordville Hotel</p>
          <p>675 Conchester Hwy<br/>
            Glen Mills, PA 19342<br/>
            610.358.9400 x. 0</p>
          <p>We have reserved a block of rooms for you!
            Please book your room with our <a href="https://www.bestwestern.com/en_US/book/hotel-rooms.39066.html?groupId=8A2VI3I8">**Hotel Link**cd its</a> </p>
        </div>
        <div class="nested_pic"><img src="../assets/images/bed.png"/></div>
      </div>
      <div class="box2">
        <div class="nested_pic"><img src="../assets/images/bus.png"/></div>
        <div class="nested_txt">
          <h4>Transportation</h4>
            <p>Shuttle will be provided to and from the Best Western to Ceremony and Reception</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3061.5334862726754!2d-75.52655344877851!3d39.88468649564707!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c6effbcf5a4ea5%3A0xa359fcb71e1ae55e!2sBest%20Western%20Plus%20Concordville%20Hotel!5e0!3m2!1sen!2sus!4v1596408131848!5m2!1sen!2sus" width="600" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
//

export default {
};
</script>

<style scoped>
</style>
